import { BaseFormComponent } from "../../../../shared/components/base-form/base-form.component";
import { Component, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { ActivatedRoute, Router } from "@angular/router";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import { RiscosChavesServices } from "../../../../services/riscos-chaves.service";
import { TipoUniversoService } from "../../../../services/tipo-universo.service";
import { CriteriosAvaliacaoRiscoService } from "../../../../services/criterios-avaliacao-risco.service";
import { MatDialog } from "@angular/material/dialog";
import {
	IRiscosChavesModel,
	IRiscosChavesProcessoItemModel,
} from "../../../../models/riscos-chaves.model";
import {
	ITipoUniversoItemModel,
	ITipoUniversoUGModel,
} from "../../../../models/tipo-universo.model";
import { SharedService } from "../../../../services/shared.service";

@Component({
	selector: "app-visualizar-riscos-chaves",
	templateUrl: "./visualizar-riscos-chaves.component.html",
	styleUrls: ["./visualizar-riscos-chaves.component.scss"],
})
export class VisualizarRiscosChavesComponent
	extends BaseFormComponent
	implements OnInit
{
	public modelRiscosChaves = {} as IRiscosChavesModel;

	unidadeGestora: number;
	public tipoUniversoId: number;
	public unidadeGestoraId: number;
	public criterioAvaliacaoId: number;
	public criterioId: string;
	public dataCriacaoFormatada: string;
	versao: number;
	titulo: string = "";
	nomeRiscoChaves: string = "";
	public modelTipoUniversoItens: ITipoUniversoUGModel =
		{} as ITipoUniversoUGModel;
	public idClassificacaoTipo: number;
	public modelRiscosChavesProcessoItemModel: IRiscosChavesProcessoItemModel[] =
		[];

	constructor(
		toastr: ToastrService,
		route: ActivatedRoute,
		router: Router,
		localeService: BsLocaleService,
		private riscosChavesService: RiscosChavesServices,
		private tipoUniversoService: TipoUniversoService,
		private criterioAvaliacaoService: CriteriosAvaliacaoRiscoService,
		private sharedService: SharedService,
		public matDialog: MatDialog
	) {
		super(route, toastr, router, localeService, matDialog);
	}

	async ngOnInit() {
		if (this.id) {
			const res = await this.riscosChavesService.obterPorId(this.id);
			if (res.sucesso) {
				this.tipoUniversoId = res.dados.tipoUniversoAuditavelId;
				this.unidadeGestoraId = res.dados.unidadeGestoraId;
				this.criterioAvaliacaoId = res.dados.criterioAvaliacaoId;
				this.nomeRiscoChaves = res.dados.nomeTipoUniverso;
				this.versao = res.dados.versao;
				this.dataCriacaoFormatada = res.dados.dataCriacaoFormatada;
			}
		}
		if (this.tipoUniversoId != null) {
			this.buscarTipoUniverso(this.tipoUniversoId);
		}
	}

	public async buscarTipoUniverso(idTipo: number) {
		const res = await this.tipoUniversoService.obterPorId(idTipo);
		if (res.sucesso) {
			this.idClassificacaoTipo = res.dados.tipo;
		}

		this.buscarItens(this.tipoUniversoId, this.unidadeGestoraId);
	}

	public async buscarItens(idTipoUniverso: number, idUG: number) {
		const paramsUG = this.idClassificacaoTipo == 2 ? idUG : null;

		if (idTipoUniverso) {
			const res = await this.tipoUniversoService.obterItens(
				idTipoUniverso,
				paramsUG
			);
			if (res.sucesso) {
				this.modelTipoUniversoItens = res.dados;

				this.criterioId = this.criterioAvaliacaoId.toString();
			} else {
				this.exibirMensagemErro(res.mensagem.descricao);
			}

			this.obterDescricaoRisco();
			this.reordenar();
		}
	}

	public obterDescricaoRisco() {
		this.riscosChavesService
			.obterItensProcesso(this.id, null)
			.then((res) => {
				if (res.sucesso) {
					this.modelRiscosChavesProcessoItemModel = Array.isArray(
						res.dados
					)
						? res.dados
						: [res.dados];
				}
			});
	}

	public reordenar() {
		this.modelTipoUniversoItens.itens.forEach((item, idx) => {
			item.ordem = idx + 1;
			item.ordemExibicao = `1.${item.ordem.toString()}`;
			if (item.itens && item.itens.length > 0) {
				this.fnReordenacao(item);
			}
		});
	}

	public fnReordenacao(item: ITipoUniversoItemModel) {
		item.itens.forEach((subItem, subIdx) => {
			subItem.ordem = subIdx + 1;
			subItem.ordemExibicao = `${
				item.ordemExibicao
			}.${subItem.ordem.toString()}`;
			if (subItem.itens && subItem.itens.length > 0) {
				this.fnReordenacao(subItem);
			}
		});
	}

	getMagnitude(processos: any[]): { riTotal: number; rrTotal: number } {
		let riTotal = 0;
		let rrTotal = 0;

		processos.forEach((processo) => {
			const riscos = this.modelRiscosChavesProcessoItemModel.filter(
				(r) => r.processoId === processo.id
			);

			riscos.forEach((risco) => {
				riTotal += risco.ri || 0;
				rrTotal += risco.rr || 0;
			});
		});

		return {
			riTotal: parseFloat(riTotal.toFixed(2)),
			rrTotal: parseFloat(rrTotal.toFixed(2)),
		};
	}

	getMagnitudeMacro(macros: any[]): { riTotal: number; rrTotal: number } {
		let riTotal = 0;
		let rrTotal = 0;

		macros.forEach((macro) => {
			const magnitudeMacro = this.getMagnitude(macro.itens);
			riTotal += magnitudeMacro.riTotal;
			rrTotal += magnitudeMacro.rrTotal;
		});

		return {
			riTotal: parseFloat(riTotal.toFixed(2)),
			rrTotal: parseFloat(rrTotal.toFixed(2)),
		};
	}

	getMagnitudeTotal(): { riTotal: number; rrTotal: number } {
		let riTotal = 0;
		let rrTotal = 0;

		if (
			!this.modelTipoUniversoItens?.itens ||
			this.modelTipoUniversoItens.itens.length === 0
		) {
			return { riTotal: 0, rrTotal: 0 };
		}

		this.modelTipoUniversoItens.itens.forEach((subtipo) => {
			const magnitudeSubtipo = this.getMagnitudeMacro(
				subtipo.itens ?? []
			);
			riTotal += magnitudeSubtipo.riTotal;
			rrTotal += magnitudeSubtipo.rrTotal;
		});

		return {
			riTotal: parseFloat(riTotal.toFixed(2)),
			rrTotal: parseFloat(rrTotal.toFixed(2)),
		};
	}

	getRiscosPorProcesso(processoId: number) {
		const riscos = this.modelRiscosChavesProcessoItemModel.filter(
			(risco) => risco.processoId === processoId
		);
		return riscos.length > 0 ? riscos : [{ nomeRisco: "", ri: 0, rr: 0 }];
	}

	retornoAbaRisco() {
		this.router.navigateByUrl(
			`/unidades-gestoras/${this.unidadeGestoraId}?aba=4`
		);
	}

	public async abrirPreenchimento(
		processoId: number,
		modoVisualizar: boolean = false,
		subtipo: string = "",
		macroprocesso: string = "",
		processo: string = ""
	) {
		const res = await this.criterioAvaliacaoService.obterPorId(
			this.criterioAvaliacaoId
		);
		if (res.sucesso) {
			if (this.id) {
				localStorage.setItem(
					"modoVisualizar",
					modoVisualizar.toString()
				);
				this.router.navigate([
					`/preenchimento-riscos-criterios`,
					this.id,
					processoId,
					this.unidadeGestoraId,
				]);

				this.sharedService.setParamsRiscos(
					subtipo,
					macroprocesso,
					processo
				);
			}
		}
	}

	public onBack() {
		this.submit = false;
		this.router.navigateByUrl(
			`/unidades-gestoras/${this.unidadeGestoraId}?aba=4`
		);
	}
}
